import { render, staticRenderFns } from "./RaceNavigationSettings.vue?vue&type=template&id=84e1c40c&"
import script from "./RaceNavigationSettings.vue?vue&type=script&lang=js&"
export * from "./RaceNavigationSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports